module.exports = __webpack_public_path__ + "static/flag-4ce996f68d7c4f69b95fb4aa9e55cca0.mp4";